import React, { PropTypes } from 'react';
import InstagramEmbed from 'react-instagram-embed';
import classNames from 'classnames';

const InstagramFeed = ({feed}) => (
  <div className={classNames(['feed', 'instagram', { 'hidden': feed.length === 0 }])}>
    <div className="col-md-12">
      <h3>Latest Instagram Posts</h3>
    </div>
    <div className="posts">
      { feed && feed.map(post =>
        <div className="col-md-4 post instagram" key={post.code}>
          <InstagramEmbed
            url={`https://instagr.am/p/${post.code}/`}
            hideCaption
            containerTagName='div'
            onLoading={() => {}}
            onSuccess={() => console.log(this)}
            onFailure={() => {}}
          />
        </div>,
      )}
    </div>
  </div>
);

InstagramFeed.propTypes = {
  feed: PropTypes.array.isRequired,
}

export default InstagramFeed;



// WEBPACK FOOTER //
// ./src/components/latest-instagram-posts/index.js